import Ajv from 'ajv';

const ALLOWED_CUSTOM_KEYWORDS = [
  '$customPage',
  '$customInput',
  '$customField',
  '$customUI',
];

const ALLOWED_OPERATOR_KEYWORDS = ['$sections', '$sort', '$transform'];

export const AJV_ALLOWED_KEYWORDS = [
  ...ALLOWED_CUSTOM_KEYWORDS,
  ...ALLOWED_OPERATOR_KEYWORDS,
  'displayType',
  'fullWidth',
  'icon',
  'minOnMount',
  'setDefault',
  'value',
];

export const AJV_OPTIONS = {
  allErrors: true,
  coerceTypes: true,
  verbose: true,
  unicodeRegExp: false,
  code: { es5: true },
  strictTuples: false,
  strictTypes: false,
  strict: true,
};

export const configureAjv = (options = AJV_OPTIONS) => {
  const ajv = new Ajv(options);

  ajv.addVocabulary(AJV_ALLOWED_KEYWORDS);

  // Add shared generic keywords
  // https://ajv.js.org/keywords.html
  // ajv.addKeyword(fn);

  return ajv;
};
